// ListItemCard — icon-pill · title · caption · trailing action. The
// row-of-related-thing pattern used in three places already (Today's
// Trends row, Talk-Me-Down, MAT referral header rows) — extracted so
// they read consistently.

import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { cn } from '../../lib/cn';

interface ListItemCardProps {
  icon?: LucideIcon;
  iconTone?: 'primary' | 'accent' | 'success' | 'warning' | 'danger' | 'neutral';
  title: ReactNode;
  caption?: ReactNode;
  trailing?: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}

export function ListItemCard({
  icon,
  iconTone = 'primary',
  title,
  caption,
  trailing,
  onClick,
  href,
  className,
}: ListItemCardProps) {
  const body = (
    <>
      {icon ? (
        <span className={cn('list-item-icon', `list-item-icon-${iconTone}`)}>
          <Icon icon={icon} />
        </span>
      ) : null}
      <div className="list-item-body">
        <div className="list-item-title">{title}</div>
        {caption ? <div className="list-item-caption muted">{caption}</div> : null}
      </div>
      {trailing ? <div className="list-item-trailing">{trailing}</div> : null}
    </>
  );

  if (href) {
    return (
      <a href={href} className={cn('list-item-card', className)}>
        {body}
      </a>
    );
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cn('list-item-card', 'list-item-card-button', className)}>
        {body}
      </button>
    );
  }
  return <div className={cn('list-item-card', className)}>{body}</div>;
}
